import {Nut_Lp_Actions_InsertDynamicScripts} from 'nutshell-core/settings-constants';

import {useGetSetting} from '../../../core/use-get-setting';
import {useUpdateSetting} from '../../../core/use-update-setting';

export const useGetGtmId = (): {
    gtmId: string | null | undefined;
    onUpdateGtmId: (arg1?: string | null | undefined) => Promise<any>;
    isLoading: boolean;
} => {
    const {setting, isLoading} = useGetSetting({
        settingName: Nut_Lp_Actions_InsertDynamicScripts.GTM_ID_SETTING_NAME,
    });
    const updateSetting = useUpdateSetting();

    const onUpdateGtmId = (newValue?: string | null) =>
        updateSetting({
            settingName: Nut_Lp_Actions_InsertDynamicScripts.GTM_ID_SETTING_NAME,
            isGlobal: true,
            value: newValue,
        });

    return {
        gtmId: setting ? setting.value : null,
        isLoading,
        onUpdateGtmId,
    };
};
